import React, { useReducer } from "react";
import * as yup from "yup";
import { Form, Formik } from "formik";
import Modal from "react-bootstrap/Modal";
import {
  formInitialState,
  formReducer,
} from "../../../../../reducers/formReducer";
import FormErrorMessage from "../../../../UI/errorMessages/FormErrorMessage";
import { Button } from "react-bootstrap";
import axios from "../../../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import CMSFormInput from "../../../../UI/forms/CMSFormInput";

const ChangeMembershipIdModal = ({
  memberId,
  initialValue,
  show,
  member,
  setShow,
  loadItem,
}) => {
  const [formState, formDispatch] = useReducer(formReducer, formInitialState);

  const handleClose = () => setShow(false);

  const onSubmit = async (data, resetForm) => {
    formDispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(`members/change-membership-number`, {
        id: memberId,
        membershipId: data.membershipId,
      });
      formDispatch({
        type: "FORM_SUBMISSION_SUCCESS",
        payload: res.data,
      });
      handleClose();
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Action performed successfully.`,
        type: "success",
      });
      resetForm();
      formDispatch({
        type: "FORM_INITIAL_STAGE",
      });
      loadItem();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong. Please try again.";

      formDispatch({
        type: "FORM_SUBMISSION_FAILED",
        payload: errorMessage,
      });
      setTimeout(() => {
        formDispatch({
          type: "FORM_INITIAL_STAGE",
        });
      }, 5000);
    }
  };

  return (
    <Formik
      initialValues={{
        membershipId: "",
      }}
      validationSchema={yup.object({
        membershipId: yup
          .string()
          .required("Required")
          .notOneOf(
            [initialValue],
            "New number must be different from the current number",
          ),
      })}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        onSubmit(values, resetForm);
      }}
    >
      {(form) => (
        <Modal show={show} onHide={handleClose}>
          {formState.isFormSubmitting && (
            <div class="overlay">
              <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
            </div>
          )}
          <Form onSubmit={form.handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Change Membership Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="alert alert-warning" role="alert">
                By proceeding with this change, the member
                <b>
                  {" "}
                  {member.firstName} {member.lastName}'s{" "}
                </b>
                membership number will be replaced permanently.
              </div>
              <div className="mb-3">
                <label className="form-label fw-bold">
                  Current Membership Number
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={initialValue}
                  disabled
                  readOnly
                />
              </div>

              <CMSFormInput
                name="membershipId"
                label="New Membership Number"
                required={true}
                form={form}
              />
              {formState.hasSubmissionError && (
                <FormErrorMessage error={formState.formSubmissionError} />
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </Formik>
  );
};

export default ChangeMembershipIdModal;
